// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"667":"31d6cfe0","923":"31d6cfe0","951":"31d6cfe0"}[chunkId] + ".chunk.css";
};